<template>
  <p-dialog
    header="Отчет об использовании системы"
    :visible="isOpen"
    @update:visible="$emit('update:isOpen', $event)"
    modal
  >
    <div class="use-report">
      <div class="info-text">
        Сформировать отчет "Информация об использовании ПО для актов ЛПО" за
        период
      </div>
      <div class="inputs-block">
        <div>
          <div>Начало</div>
          <p-calendar
            v-model="dateFrom"
            dateFormat="dd.mm.yy"
            appendTo="body"
          />
        </div>
        <div>
          <div>Окончание</div>
          <p-calendar v-model="dateTo" appendTo="body" />
        </div>
      </div>

      <div class="checkbox-block">
        <p-checkbox
          v-model="isDraft"
          :binary="true"
          id="use-report-draft-checkbox"
        />
        <label for="use-report-draft-checkbox"
          >Включить в отчет "черновики"</label
        >
      </div>

      <div class="btn-block">
        <p-button
          label="Отмена"
          icon="fa fa-times"
          @click="$emit('update:isOpen', false)"
          class="p-button-sm p-button-secondary"
        />
        <p-button
          label="Выгрузить"
          icon="fa fa-check"
          @click="formReport"
          class="p-button-sm p-button-success"
        />
      </div>
    </div>
  </p-dialog>
</template>

<script>
const ROOT_API = process.env.VUE_APP_ROOT_API;
const FORM_REPORT = ROOT_API + "form_use_report/index.php";

import ruLocale from "@/lib/pCalendarRuLocale";

export default {
  name: "JournalLpo__useReport",

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    dateFrom: "",
    dateTo: "",
    isDraft: false,
  }),

  methods: {
    formReport() {
      if (!this.dateFrom || !this.dateTo) {
        return;
      }

      let ddFrom = this.dateFrom.getDate();
      let mmFrom = this.dateFrom.getMonth() + 1;
      const yyyyFrom = this.dateFrom.getFullYear();

      if (ddFrom < 10) ddFrom = "0" + ddFrom;
      if (mmFrom < 10) mmFrom = "0" + mmFrom;

      const from = `${ddFrom}.${mmFrom}.${yyyyFrom}`;

      let ddTo = this.dateTo.getDate();
      let mmTo = this.dateTo.getMonth() + 1;
      const yyyyTo = this.dateTo.getFullYear();

      if (ddTo < 10) ddTo = "0" + ddTo;
      if (mmTo < 10) mmTo = "0" + mmTo;

      const to = `${ddTo}.${mmTo}.${yyyyTo}`;

      console.log("date fr: ", from);
      console.log("date to: ", to);

      const form = new FormData();
      form.append("from", from);
      form.append("to", to);
      form.append("is_draft", this.isDraft);

      this.isForming = true;
      fetch(FORM_REPORT, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          const a = document.createElement("a");

          a.setAttribute("href", res.file);
          a.setAttribute("download", res.name);

          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((err) => {
          this.$toast.add({
            severity: "warn",
            detail: "При формировании информации для реестров произошла ошибка",
            life: 10000,
          });

          throw err;
        })
        .finally(() => {
          this.isForming = false;
        });
    },
  },

  created() {
    this.$primevue.config.locale = ruLocale;
  },
};
</script>

<style scoped>
.use-report {
  max-width: 400px;
}

.info-text {
  white-space: wrap;
  margin-bottom: 2rem;
}

.inputs-block {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.checkbox-block {
  display: flex;
  gap: 0.7rem;
  align-items: center;
  margin-bottom: 2rem;
}

.checkbox-block > label {
  display: flex;
  gap: 1rem;
  font-style: italic;
}

.btn-block {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}
</style>
